import { useState } from "react";
import { Form, Dropdown, FormControl } from "react-bootstrap";

/**
 * BWStatusFilter - Reusable B:W status filter dropdown
 * @param {Array} bwOptions - Options for B:W status
 * @param {Array} value - Selected values
 * @param {Function} setValue - Setter for selected values
 */
const BWStatusFilter = ({ bwOptions, value, setValue }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState("");

  return (
    <div style={{ maxWidth: 220 }}>
      <Form.Group
        className="mb-3"
        controlId="bwDropdownGroup"
        style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 12 }}
      >
        <Form.Label
          style={{ fontWeight: "bold", minWidth: 40, marginBottom: 0, whiteSpace: "nowrap" }}
        >
          B:W
        </Form.Label>
        <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)}>
          <Dropdown.Toggle
            variant="light"
            style={{
              width: "125px",
              textAlign: "left",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              background: "#fff",
              color: "#222",
              border: "1px solid #ced4da",
              boxShadow: "none",
              borderRadius: "5px",
            }}
            title={
              value.length === 0
                ? "Select B:W"
                : bwOptions
                    .filter((opt) => value.includes(opt.value))
                    .map((opt) => opt.label)
                    .join(", ")
            }
          >
            <span
              style={{
                display: "inline-block",
                maxWidth: 140,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                verticalAlign: "middle",
              }}
            >
              {value.length === 0
                ? "Select B:W"
                : bwOptions
                    .filter((opt) => value.includes(opt.value))
                    .map((opt) => opt.label)
                    .join(", ")}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ width: 180, padding: 8 }}>
            <FormControl
              autoFocus
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                marginBottom: 8,
                background: "#fff",
                color: "#222",
                boxShadow: "none",
                borderColor: "#ced4da",
              }}
            />
            <div style={{ maxHeight: 180, overflowY: "auto", background: "#fff" }}>
              {bwOptions
                .filter((opt) => opt.label.toLowerCase().includes(search.toLowerCase()))
                .map((opt) => (
                  <Form.Check
                    key={opt.value}
                    type="checkbox"
                    id={`bw-filter-${opt.value}`}
                    label={opt.label}
                    checked={value.includes(opt.value)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setValue([...value, opt.value]);
                      } else {
                        setValue(value.filter((v) => v !== opt.value));
                      }
                    }}
                    style={{ marginBottom: 4 }}
                  />
                ))}
              {bwOptions.filter((opt) => opt.label.toLowerCase().includes(search.toLowerCase()))
                .length === 0 && (
                <div style={{ color: "#888", padding: 8 }}>No options found</div>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>
    </div>
  );
};

export default BWStatusFilter;
